<div *ngIf="user">
  <table class="table">
    <tr>
      <td>First Name</td> <td>{{user.firstname}}</td>
  </tr>
  <tr>
      <td>Last Name</td> <td>{{user.lastname}}</td>
  </tr>
  <tr>
      <td>Username</td> <td>{{user.username}}</td>
  </tr>
      <tr>
          <td>Enabled</td>
          <td>
              <i *ngIf="user.is_account_enabled!=1" class='fa fa-square-o'></i>
              <i *ngIf="user.is_account_enabled==1" class='fa fa-check-square-o'></i>

              <span *ngIf="authService.isAdmin()">
                <span *ngIf="user.is_account_enabled==1" class='text-danger'>
                  <button (click)="enableDisableUser(user.server_user_id)" class="btn btn-danger btn-sm">Disable</button>
                </span>
                <span *ngIf="user.is_account_enabled!=1" class='text-success'>
                  <button (click)="enableDisableUser(user.server_user_id)" class="btn btn-success btn-sm">Enable</button>
                </span>
              </span>

          </td>
      </tr>
      <tr>
          <td>Locked</td>
          <td>
              <i *ngIf="user.is_account_locked!=1" class='fa fa-square-o'></i>
              <i *ngIf="user.is_account_locked==1" class='fa fa-check-square-o'></i>

              <span *ngIf="authService.isAdmin()">
                <span *ngIf="user.is_account_locked==1" class='text-danger'>
                  <button (click)="lockUnlockUser(user.server_user_id)" class="btn btn-danger btn-sm">Unlock</button>
                </span>
                <span *ngIf="user.is_account_locked!=1" class='text-success'>
                  <button (click)="lockUnlockUser(user.server_user_id)" class="btn btn-success btn-sm">Lock</button>
                </span>
              </span>

          </td>
      </tr>
      <tr>
          <td>Expired</td>
          <td>
              <i *ngIf="user.is_account_expired!=1" class='fa fa-square-o'></i>
              <i *ngIf="user.is_account_expired==1" class='fa fa-check-square-o'></i>
          </td>
      </tr>
      <tr>
          <td>Last Login</td>
          <td>{{user.last_login}}</td>
      </tr>
      <tr>
          <td>Created</td>
          <td>{{user.dateCreated}}</td>
      </tr>
      <tr>
          <td>Updated</td>
          <td>{{user.dateUpdated}}</td>
      </tr>
      <tr *ngIf="authService.isGranted('ROLE_ADMIN')">
          <td>Roles</td>
          <td>
              <span *ngFor="let role of user.roles">
                  {{role.name}}&nbsp;
              </span>
          </td>
      </tr>
      </table>

  <fieldset class="text-center">
  <a [routerLink]="['/user/general/edit',user.server_user_id]" class="btn btn-primary me-4"> <i class="fa fa-edit"></i>Edit User</a>
  <a *ngIf="authService.isGuardian()" [routerLink]="['/guardian/show',guardian.server_user_id]"
        class="btn btn-danger  me-4" data-dismiss="modal"> <i class="fa fa-home"> </i>Guardian Home
      </a>
      <a *ngIf="authService.isAdmin()" [routerLink]="['/home/admin/show']" class="btn btn-danger  me-4"> <i class="fa fa-home"></i>Admin Hone</a>
      <a *ngIf="authService.isAdmin()" [routerLink]="['/admin/user/index']" class="btn btn-danger"> <i class="fa fa-list"></i>  User List</a>

  </fieldset>
    </div>

